export default {
  createNewOrganisations: process.env.VUE_APP_FEAT_ORGANISATIONS_CREATE_NEW,
  upgradeOrganisations: process.env.VUE_APP_FEAT_ORGANISATIONS_UPGRADE,
};
